import styled from 'styled-components';
import LobCabIconSvg from './icon-lob-cab.svg';

const LobCabIcon = styled(LobCabIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || ''};
  
`;

export default LobCabIcon;

